import ConsultantInterest from './ConsultantInterest';
export default ConsultantInterest;